<template>
  <div>
    <h3 class="title-func" id="introduction">
      <LabelFunMessage fcontId="0" msgkey="33" />
    </h3>

    <div class="how_step article">
      <div class="row">
        <div
          class="col-sm-8 col-md-8 col-lg-8 col-sm-push-4 col-md-push-4 col-lg-push-4"
        >
          <p class="indent_caption">
            <LabelFunMessage fcontId="0" msgkey="162" />
          </p>
          <p>
            <LabelFunMessage fcontId="0" msgkey="163" />
            <br />
            <LabelFunMessage fcontId="0" msgkey="164" />
            <br />
            <LabelFunMessage fcontId="0" msgkey="165" />
          </p>

          <p>
            <a href="https://www.toy-spice.jp/" target="_blank" rel="noopener">
              <LabelFunMessage fcontId="0" msgkey="166" />
            </a>
          </p>
          <p>
            <a
              href="https://www.postcardtoy.com/"
              target="_blank"
              rel="noopener"
            >
              <LabelFunMessage fcontId="0" msgkey="167" />
            </a>
          </p>
        </div>
        <!--/col-->

        <div
          class="col-sm-4 col-md-4 col-lg-4 col-sm-pull-8 col-md-pull-8 col-lg-pull-8"
        >
          <img
            :src="app_root + '/assets/common/img/creator/gotomochika.png'"
            class="img-responsive center-block"
          />
        </div>
        <!--/col-->
      </div>
      <!--/row-->
    </div>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "CreatorProfileGoTomochika",
  components: {
    LabelFunMessage,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>